import React from "react";
import { Button, Popover } from "antd";

import WaybillNoExportExportItem from "@/services/api/moreFeatures/shippingCostStat/enum/WaybillNoExportExportItem";
import { WaybillFieldCheckboxGroup } from "./WaybillFieldCheckboxGroup";
import "./TaskSettings.less";

interface TaskInfoItemProps {
    label: string;
    children: React.ReactNode;
    labelStyle?: React.CSSProperties;
}

export const TaskInfoItem: React.FC<TaskInfoItemProps> = ({ label, children, labelStyle }) => {
    return (
        <div className="waybill-export-task-info-item">
            <span className="waybill-export-task-info-label" style={labelStyle}>
                {label}：
            </span>
            <div className="waybill-export-task-info-content">{children}</div>
        </div>
    );
};

interface TaskSettingsProps {
    exportItems?: WaybillNoExportExportItem[];
    totalExportItems?: WaybillNoExportExportItem[];
}

const TaskSettings: React.FC<TaskSettingsProps> = ({ exportItems, totalExportItems }) => {
    if (exportItems === undefined) return null;

    return (
        <div className="waybill-export-task-info">
            <TaskInfoItem label="导出信息" labelStyle={{ flex: "0 0 70px" }}>
                <Popover
                    trigger="click"
                    content={
                        <div className="waybill-export-task-settings-popover">
                            <WaybillFieldCheckboxGroup
                                value={exportItems}
                                totalExportItems={totalExportItems}
                                needProductInfo
                                editable={false}
                            />
                        </div>
                    }
                >
                    <Button type="link" className="waybill-export-task-settings-link">
                        查看导出信息
                    </Button>
                </Popover>
            </TaskInfoItem>
        </div>
    );
};

export default React.memo(TaskSettings);
